module.exports = __webpack_public_path__ + "static/media/card2.fc92e44c.png";